import React from 'react';
import PropTypes from 'prop-types';
import { t, defineMessages } from '@sm/intl';

const DEFAULT_COPY = defineMessages({
  POINT: {
    id: 'QuizResultScore.POINT',
    defaultMessage: 'point',
    description: '[Type: header][Vis: med] - total point of this quiz question',
  },
  POINTS: {
    id: 'QuizResultScore.POINTS',
    defaultMessage: 'points',
    description: '[Type: header][Vis: med] - total point of this quiz question',
  },
  SKIPPED: {
    id: 'QuizResultScore.SKIPPED',
    defaultMessage: 'Skipped',
    description: '[Type: header][Vis: med] - user skipped this quiz question',
  },
});

const QuizResultScore = ({ type }) => (
  <span>
    <Choose>
      <When condition={type === 'point'}>{t(DEFAULT_COPY.POINT)}</When>
      <When condition={type === 'points'}>{t(DEFAULT_COPY.POINTS)}</When>
      <When condition={type === 'skipped'}>{t(DEFAULT_COPY.SKIPPED)}</When>
    </Choose>
  </span>
);

QuizResultScore.propTypes = {
  type: PropTypes.string.isRequired,
};

export default QuizResultScore;
